
import UserLayout from '@/layouts/UserLayout';
import BasicLayout from '@/layouts/BasicLayout';
import RouteView from '@/layouts/RouteView';

//权限路由
export const asyncRouterMap = [
    {
        path: '/',
        redirect: '/order',
        component: BasicLayout,
        children: [
            {
                path: '/order',
                redirect: '/order/order_list',
                component: RouteView,
                children: [
                    {
                        path: '/order/order_list',
                        component: () => import('@/pages/order/OrderList')
                    },
                ]
            },
            {
                path: '/customer',
                redirect: '/customer/customer_list',
                component: RouteView,
                children: [
                    {
                        path: '/customer/customer_list',
                        component: () => import('@/pages/customer/CustomerList')
                    },
                    {
                        path: '/customer/activation_code_list',
                        component: () => import('@/pages/customer/ActivationCodeList')
                    },
                ]
            },
            {
                path: '/finance',
                redirect: '/finance/balance_log',
                component: RouteView,
                children: [
                    {
                        path: '/finance/balance_log',
                        component: () => import('@/pages/finance/BalanceLog')
                    },
                ]
            },
            {
                path: '/set',
                redirect: '/set/account',
                component: RouteView,
                children: [
                    {
                        path: '/set/account',
                        redirect: '/set/account/basic',
                        component: () => import('@/pages/set/account/Index'),
                        children: [
                            {
                                path: '/set/account/basic',
                                component: () => import('@/pages/set/account/Basic')
                            },
                            {
                                path: '/set/account/security',
                                component: () => import('@/pages/set/account/Security')
                            },
                        ]
                    },
                ]
            },
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404',
    }
]

//基础路由
export const constantRouterMap = [
    {
        path: '/agent', 
        redirect: '/agent/login',
        component: UserLayout,
        meta:{
            title:'登录'
        },
        children: [
            {
                path: 'login',
                name:'login',
                component: () => import('@/pages/agent/Login')
            },
        ]
    },
    {
        path: '/404',
        component: () => import( '@/pages/404')
    }
];